import { cssUtil } from "../utils/cssUtil.js";
import { getBaseStyles } from "./commonStyles.js";
const IMAGE_CDN_ENDPOINT = process.env.REACT_APP_IMAGE_CDN;

export async function renderAssetWidget(context, widget, parent, override = null) {

    const breakpoint = context.currentBreakpoint;
    const props = widget?.properties?.desktop;

    // Root wrapper
    const root = context.document.createElement("div");
    root.classList.add("widget", "asset_widget");

    const rootStyles = {
        ...getBaseStyles(widget, breakpoint),
        width: "100%"
    };
    root.setAttribute("style", cssUtil.toStyleString(rootStyles));
    root.setAttribute("data-widgetId", widget.uid);
    root.setAttribute("data-widgetType", widget.type);
    root.setAttribute("data-widgetParent", widget.parent);

    // Resolve URLs
    const assetUrl = getAssetUrl(context, widget);
    const hrefUrl = getHrefUrl(context, widget);

    // Anchor
    const anchor = context.document.createElement("a");
    anchor.classList.add("widget", "image_widget");

    if (hrefUrl) {
        anchor.setAttribute("href", hrefUrl);
    }

    anchor.setAttribute(
        "style",
        cssUtil.toStyleString(getAnchorStyles(widget, breakpoint))
    );


        const img = context.document.createElement("img");

        if (assetUrl) {
            img.setAttribute("src", assetUrl);
        }

        img.setAttribute(
            "style",
            cssUtil.toStyleString(getMediaStyles(widget))
        );

        anchor.appendChild(img);

    root.appendChild(anchor);
    parent.appendChild(root);

    // Render children
    const children = context.widgets.filter(w => w.parent === widget.uid);
    if (!children || !children.length) return root;

    for (const child of children) {
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;

        const renderer = context.renderers[child.type];
        if (!renderer) continue;

        await renderer(context, child, root);
    }
}

function getAnchorStyles(widget, breakpoint) {
    const styles = {
        width: "100%",
        top: "0px"
    };

    const layout = widget?.properties?.[breakpoint]?.layout;
    if (layout?.height) {
        styles.height = layout.height;
    }

    return styles;
}


function getMediaStyles(widget, breakpoint) {
    const styles = {};
    const layout = widget?.properties?.[breakpoint]?.layout;

    if (layout?.width) {
        styles.width = layout.width;
    }

    if (layout?.height) {
        styles.height = layout.height;
    }

    return styles;
}

function getAssetUrl(context, widget) {
    const props = widget?.properties?.desktop;

    // Asset mapping
    const content = widget.content;
    if (content) {
        const mapping = content.content;

        if (mapping?.asset?.icon?.fullUrl) {
            return mapping.asset.icon.fullUrl;
        }
    }

    // Fallback
    return `${IMAGE_CDN_ENDPOINT}/public/cleverstory/v2/static/default_card.jpg`;
}

function getHrefUrl(context, widget) {
    const content = widget.content;
    if (!content) return "";

    const mapping = content.content;

    if (!mapping) return "";

    const alias = mapping?.asset?.alias;
    if (!alias) return "";

    const domain = context.storyboard.domain;
    if (!domain) return "";

    return `${domain.url}${alias}`;
}
